import { render } from "./risk_questions.html?vue&type=template&id=3236b6fa&external"
import script from "./risk_questions.js?vue&type=script&lang=js&external"
export * from "./risk_questions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__